import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=4be78b04&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style1 from "./Index.vue?vue&type=style&index=1&id=4be78b04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be78b04",
  null
  
)

export default component.exports